module.exports = __webpack_public_path__ + "assets/img/TabBar_Setting.4a9063e8.svg";